import { useAxiosRequest } from "api/axiosRequest"
import { BASE_URL } from "api/url_helper"
import axios from "axios"
import { useState } from "react"
import { toast } from "react-toastify"
import { AddVesselStruct } from "./useAddVesselToList"

export interface VesselInfo extends AddVesselStruct{
    id: string
}

export function useFetchVesselInfo(){
    const request = useAxiosRequest()
    async function getVesselInfo(listID: string[]){
        return request<any, VesselInfo[]>({
            url:`${BASE_URL}/vesseltracking/vessel`,
            params: {listID},
            method:"GET",
        }).then((response)=>response?.data)
    }
    const [vesselInfos, setVesselInfos] = useState<VesselInfo[] | undefined>([])
    const [isGetVesselInfoLoading, setIsGetVesselInfoLoading] = useState<boolean>(false)

    async function fetchVesselInfo(listID: string[]){
        setIsGetVesselInfoLoading(true)
        setVesselInfos(undefined)
        try{ 
            const response = await getVesselInfo(listID)
            if(response){
                setVesselInfos(response)
            }
        } catch(err: unknown){
            const message = "Unable to fetch vessel info"
            if(axios.isAxiosError(err)){
                toast.warn(message, {
                    position:"bottom-right",
                    autoClose: 8000,
                })
            }
        } finally{
            setIsGetVesselInfoLoading(false)
        }
    }
    return {vesselInfos, fetchVesselInfo, isGetVesselInfoLoading}
}